import * as ImagePicker from 'expo-image-picker';

export const launchImageLibraryAsync = ImagePicker.launchImageLibraryAsync;
